import { render } from "./CreateUserForm.vue?vue&type=template&id=b160d4d2"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"

import "./CreateUserForm.vue?vue&type=style&index=0&id=b160d4d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__